// import { authService } from '../../services/auth.service.local'
import { authService } from "@/services/auth.service";
// import { logger } from '../../services/logger.service'

export const authStore = {
  state: {
    loggedInUser: null,
    // sessionToken: '',
    otpGuid: null,
  },
  getters: {
    loggedInUser({ loggedInUser }) {
      return loggedInUser;
    },
    // sessionToken({ sessionToken }) {
    //     return sessionToken
    // },
  },
  mutations: {
    setLoggedInUser(state, { user }) {
      state.loggedInUser = user ? { ...user } : null;
    },
    // setSessionToken(state, { sessionToken }) {
    //     state.sessionToken = sessionToken
    // },

    setOtpGuid(state, { otpGuid }) {
      state.otpGuid = otpGuid;
    },
  },
  actions: {
    async firstFactorAuth({ commit }, { userName, pswd, compId, sendType }) {
      try {
        // if you need otpExpirySeconds you can get it from the sendTo
        // const { otpGuid ,otpExpirySeconds} = await authService.firstFactorAuth(userCred)
        const { otpGuid } = await authService.firstFactorAuth(
          userName,
          pswd,
          compId,
          sendType
        );

        commit({ type: "setOtpGuid", otpGuid });
      } catch (err) {
        console.error("authStore: Error in firstFactorAuth", err);
        throw err;
      }
    },
    async sendAgainOtpCode({ commit, state }) {
      try {
        // if you need otpExpirySeconds you can get it from the sendTo
        // const { otpGuid ,otpExpirySeconds} = await authService.sendOtpCode(userCred)
        const { otpGuid } = await authService.sendAgainOtpCode(state.otpGuid);

        commit({ type: "setOtpGuid", otpGuid });
      } catch (err) {
        console.error("authStore: Error in sendAgainOtpCode", err);
        throw err;
      }
    },
    async secondFactorAuth({ commit, state }, { otpCode }) {
      try {
        const user = await authService.secondFactorAuth(otpCode, state.otpGuid);
        commit({ type: "setLoggedInUser", user });
      } catch (err) {
        console.error("authStore: Error in secondFactorAuth", err);
        throw err.response.data;
      }
    },

    async logout({ commit }) {
      try {
        await authService.logout();
        commit({ type: "setLoggedInUser", user: null });
      } catch (err) {
        console.error("userStore: Error in logout", err);
        throw err;
      }
    },

    async loadUser({ commit }) {
      try {
        const user = await authService.getLoggedInUser();
        // console.log('loadUser user', user)
        // const sessionToken = await authService.getSessionToken()
        if (user) {
          commit({ type: "setLoggedInUser", user });
          // commit({ type: 'setSessionToken', sessionToken })
        }
        return user;
      } catch (err) {
        console.error("userStore: Error in loadUser", err);
        throw err;
      }
    },
  },
};
